import React from 'react';
import { Radio as AntRadio } from 'antd';
import { RadioButtonProps } from 'antd/lib/radio/radioButton';

export interface IRadioButtonProps extends RadioButtonProps {}

/**
 * Radio Button component
 */

const RadioButton: React.FC<IRadioButtonProps> = (
  props: IRadioButtonProps,
  ref: React.Ref<unknown>
) => <AntRadio.Button {...props} ref={ref} />;

export default RadioButton;
